<section (click)="detenerSonido()">
  <div class="information">
    <mat-card>
      <mat-card-header
        [ngClass]="{
          success: pickupService.pedidoActivo.segundos <= 180,
          warning:
            pickupService.pedidoActivo.segundos > 180 &&
            pickupService.pedidoActivo.segundos <= 300,
          danger: pickupService.pedidoActivo.segundos > 300
        }"
      >
        <img
          *ngIf="pickupService.pedidoActivo.tipo == 'food'"
          class="icontipo"
          src="assets/images/sod.png"
        />
        <img
          *ngIf="pickupService.pedidoActivo.tipo == 'BT'"
          class="icontipo"
          src="assets/images/babytuto.png"
        />
        <img
          *ngIf="pickupService.pedidoActivo.tipo == 'Catex'"
          class="icontipo"
          src="assets/images/catex.png"
        />
        <mat-card-title>
          {{ pickupService.pedidoActivo.nombrecliente }}
        </mat-card-title>
        <mat-card-subtitle>{{
          pickupService.pedidoActivo.sg123
        }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="information">
        <table style="width: 100%">
          <tr>
            <td>
              <table>
                <tr>
                  <td>
                    <mat-icon>local_play</mat-icon>
                  </td>
                  <td>Orden</td>
                  <td>{{ pickupService.pedidoActivo.orden }}</td>
                </tr>
                <tr>
                  <td>
                    <mat-icon>person</mat-icon>
                  </td>
                  <td>RUT</td>
                  <td>{{ pickupService.pedidoActivo.rut }}</td>
                </tr>
                <tr class="reagendar-container">
                  <td>
                    <mat-icon>event_available</mat-icon>
                  </td>
                  <td>Fecha retiro</td>
                  <td>
                    <p>
                      {{ pickupService.pedidoActivo.fecharetiro }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-icon>access_time</mat-icon>
                  </td>
                  <td>Ventana</td>
                  <td>
                    <span
                      >{{ pickupService.pedidoActivo.ventana.split(" ")[0]
                      }}<br
                    /></span>
                    <span>{{
                      pickupService.pedidoActivo.ventana.split(" ")[1]
                    }}</span>
                  </td>
                </tr>
                <tr
                  *ngIf="
                    pickupService.pedidoActivo.status === 'Cliente esperando'
                  "
                >
                  <td>
                    <mat-icon>timer</mat-icon>
                  </td>
                  <td>Tiempo de espera</td>
                  <td>{{ pickupService.pedidoActivo.tiempo }}</td>
                </tr>
                <tr
                  *ngIf="
                    pickupService.pedidoActivo.status === 'Compra aceptada' &&
                    pickupService.pedidoActivo.hora_llegada_estimada
                  "
                >
                  <td>
                    <mat-icon>business_center</mat-icon>
                  </td>
                  <td>Llega en</td>
                  <td>{{ pickupService.pedidoActivo.eta }}</td>
                </tr>
                <tr *ngIf="pickupService.pedidoActivo.id_runner > 0">
                  <td>
                    <mat-icon>directions_run</mat-icon>
                  </td>
                  <td>Runner asignado</td>
                  <td>{{ pickupService.pedidoActivo.runner }}</td>
                </tr>
                <tr
                  *ngIf="
                    pickupService.pedidoActivo.status == 'Cliente esperando'
                  "
                >
                  <td>
                    <mat-icon>person_pin_circle</mat-icon>
                  </td>
                  <td>Ubicación cliente</td>
                  <td>{{ pickupService.pedidoActivo.zona_entrega }}</td>
                </tr>
                <tr
                  *ngIf="
                    pickupService.pedidoActivo.ubicacion_bodega != '' &&
                    pickupService.pedidoActivo.ubicacion_bodega
                  "
                >
                  <td>
                    <mat-icon>location_on</mat-icon>
                  </td>
                  <td>Ubicación bodega</td>
                  <td>{{ pickupService.pedidoActivo.ubicacion_bodega }}</td>
                </tr>
                <tr *ngIf="pickupService.pedidoActivo.modo_retiro">
                  <td>
                    <mat-icon>store_mall_directory</mat-icon>
                  </td>
                  <td>Modo retiro</td>
                  <td>{{ pickupService.pedidoActivo.modo_retiro }}</td>
                </tr>
                <tr>
                  <td>
                    <mat-icon>abc</mat-icon>
                  </td>
                  <td>Patente</td>
                  <td>{{ pickupService.pedidoActivo.patente }}</td>
                </tr>
              </table>
            </td>
            <td style="text-align: center">
              <img
                *ngIf="pickupService.pedidoActivo.notificacion_llegada == 'pwa'"
                height="60"
                src="assets/images/pwa_icon.png"
              />
              <img
                *ngIf="pickupService.pedidoActivo.notificacion_llegada == 'qr'"
                height="60"
                src="assets/images/qr_icon.png"
              />
              <img
                *ngIf="
                  pickupService.pedidoActivo.notificacion_llegada == 'llamada'
                "
                height="60"
                src="assets/images/ivr_icon.png"
              />
              <img
                *ngIf="
                  pickupService.pedidoActivo.notificacion_llegada == 'meson'
                "
                height="60"
                src="assets/images/meson_icon.png"
              />
              <img
                *ngIf="
                  pickupService.pedidoActivo.notificacion_llegada == 'whatsapp'
                "
                height="60"
                src="assets/images/whatsapp_icon.png"
              />
            </td>
          </tr>
        </table>
      </mat-card-content>
      <mat-card-footer>
        <table>
          <tr class="comentario-container">
            <td>
              <mat-icon>insert_comment</mat-icon>
            </td>
            <td>Comentario</td>
            <td>
              {{
                utilityService.stringReducerResume(
                  pickupService.pedidoActivo.comentario_runner,
                  20
                ) || "Sin comentario"
              }}
              <span>
                <button (click)="goComentarios()" color="primary" mat-fab>
                  <mat-icon>edit</mat-icon>
                </button>
              </span>
            </td>
          </tr>
        </table>
      </mat-card-footer>
    </mat-card>
  </div>
  <div class="bultos-container">
    <mat-card>
      <mat-card-header class="bultos-header" style="display: block !important">
        <span>Bultos : {{ pickupService.pedidoActivo.bultos.length }}</span>
        <span style="float: right">
          <button
            (click)="colapsarBultos()"
            color="primary"
            mat-fab
            style="width: 36px; height: 36px"
          >
            <mat-icon *ngIf="bultos_colapsados">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="!bultos_colapsados">keyboard_arrow_right</mat-icon>
          </button>
        </span>
      </mat-card-header>
      <mat-card-content *ngIf="bultos_colapsados">
        <mat-accordion>
          <ng-container *ngFor="let ubicacion of getUbicaciones()">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title
                  style="
                    text-decoration: underline;
                    display: block;
                    height: 30px !important;
                  "
                >
                  <b>{{ ubicacion }}</b>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex-container">
                <div
                  *ngFor="let bulto of bultosPorUbicacion[ubicacion].bultos"
                  class="container_bulto"
                >
                  <table style="width: 100%">
                    <tr>
                      <td style="display: flex; gap: 16px">
                        <mat-icon>shopping_bag</mat-icon>
                        {{ bulto.id
                        }}{{
                          bulto.id == "1007500000000"
                            ? " (" + bulto.nunidades + ")"
                            : ""
                        }}
                        <mat-spinner
                          *ngIf="bulto.enCola"
                          diameter="16"
                          color="primary"
                        ></mat-spinner>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style="
                          text-align: right;
                          color: gray;
                          text-decoration: dotted;
                        "
                      >
                        <i>{{ bulto.descripcion }}</i>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="buttons">
    <button
      (click)="escanearQrEntrega()"
      class="button btnlarge"
      color="primary"
      mat-raised-button
    >
      <mat-icon> check</mat-icon>&nbsp;Entregar pedido
    </button>

    <div class="button-group">
      <a
        (click)="logLlamarCliente(pickupService.pedidoActivo.celular)"
        class="bg-success button btnlarge"
        href="tel:+{{ pickupService.pedidoActivo.celular }}"
        mat-raised-button
        style="
          font-size: 1.2rem;
          text-align: center;
          margin: 0px !important;
          margin-left: 20px !important;
          margin-bottom: 20px !important;
        "
      >
        <mat-icon> call</mat-icon>&nbsp;Llamar al cliente</a
      >
      <button
        (click)="presentAlertConfirm()"
        *ngIf="pickupService.pedidoActivo.status == 'Cliente esperando'"
        [disabled]="resetLlegadaLocker()"
        class="bg-warning button btnlarge"
        mat-raised-button
        style="font-size: 1.2rem; text-align: center; margin: 0px !important"
      >
        Cliente no ha llegado
      </button>
      <button
        (click)="pickerManual()"
        *ngIf="
          pickupService.pedidoActivo.status !== 'Entregado' &&
          pickupService.pedidoActivo.status !== 'Cliente en camino'
        "
        class="button btnlarge"
        mat-raised-button
        style="
          background-color: orange;
          color: white;
          font-size: 1.2rem;
          text-align: center;
          margin: 0px !important;
          margin-right: 20px !important;
          margin-bottom: 20px !important;
        "
      >
        <mat-icon>shopping_bag</mat-icon>&nbsp;Binear Pedido
      </button>
    </div>

    <button
      (click)="volverListado()"
      class="btnlarge"
      color="link"
      mat-raised-button
    >
      <mat-icon>arrow_back</mat-icon>
      Volver al listado
    </button>
  </div>
</section>
